<div>
    <label>As Of Date</label>
    <lf-datepicker [(ngModel)]="filters.asOfDate" [useTimepicker]="false" ngDefaultControl>
    </lf-datepicker>
</div>
